import { openFolderPermissionsDialog } from '../actions/externalActions';
import {
    showHideFolderPermissionDialog,
    setFolderPermissionsLoader,
} from '../actions/internalActions';
import { lazyGetFolderPermissions } from 'owa-folders';
import { orchestrator } from 'satcheljs';

// Orchestrator subscribing open folder permissions action and dispatching 2 internal and 1 external action to show permissions dialog and loader
export const openFolderPermissionsDialogOrchestrator = orchestrator(
    openFolderPermissionsDialog,
    async actionMessage => {
        showHideFolderPermissionDialog(actionMessage.folderId, true /* Should show */);
        setFolderPermissionsLoader(true);
        // Dispatching action to fetch folder permissions from server.
        (await lazyGetFolderPermissions.import())(actionMessage.folderId);
    }
);
